import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CompetensesResponse, CourseResponse } from '../interfaces/response';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SectoresProductivosService {

  urlSectoresProductivos: string = `${environment.apiSectores.context}${environment.apiSectores.methods.general}`;
  requestOptions: any;
  urlEstandares: string = `${environment.apiSectores.context}${environment.apiSectores.methods.standar}`;
  urlGetDesEstandares: string = `${environment.apiSectores.context}${environment.apiSectores.methods.standarDescription}`;
  urlGetDesCertificador: string = `${environment.apiSectores.context}${environment.apiSectores.methods.certifierDescription}`;
  getDatosGenerales: string = `${environment.apiSectores.context}${environment.apiSectores.methods.generalData}`;
  getEstandaresMarcau: string = `${environment.apiSectores.context}${environment.apiSectores.methods.brandStandards}`;
  getEstandaresAllu: string = `${environment.apiSectores.context}${environment.apiSectores.methods.allStandars}`;
  getSectoresByEstandar: string = `${environment.apiSectores.context}${environment.apiSectores.methods.generalStandar}`;
  getCursoByID: string = `${environment.apiSectores.context}${environment.apiSectores.methods.courses}`;
  getFichaestandar: string = `${environment.apiSectores.context}${environment.apiSectores.methods.fichaEstandar}`;

  urlCursos: string = `${environment.apiCursos.context}${environment.apiCursos.methods.listaCursos}`;
  getDetailCurse: string = `${environment.apiCursos.context}${environment.apiCursos.methods.detalleCurso}`;
  urlRenap: string = `${environment.apiCompetencias.context}${environment.apiCompetencias.methods.listaCursos}`;


  constructor(private http: HttpClient) {
    this.requestOptions = { headers: new HttpHeaders({ 'content-type': "application/json; charset=utf-8" }) };
  }

  getSectoresProductivos(): Promise<any> {
    return this.http.get<any>(this.urlSectoresProductivos, this.requestOptions).toPromise();
  }

  getSectoresProductivosById(idSector: number, estandar: String): Promise<any> {
    return this.http.get<any>(`${this.urlSectoresProductivos}/${idSector}/${estandar}`, this.requestOptions).toPromise();
  }

  getEstandaresById(idSubsector: number, estandar: String): Promise<any> {
    return this.http.get<any>(`${this.urlEstandares}/${idSubsector}/${estandar}`, this.requestOptions).toPromise();
  }

  getDescEstandar(codigoEC: string): Promise<any> {
    let req = {
      codigoEC: codigoEC
    }
    return this.http.post<any>(`${this.urlGetDesEstandares}/${codigoEC}`, req, this.requestOptions).toPromise();
  }

  getDesCertificador(clAcreditacion: any, codigoEC: any) {
    let req = {
      clAcreditacion: clAcreditacion,
      codigoEC: codigoEC
    }
    return this.http.post<any>(`${this.urlGetDesCertificador}`, req, this.requestOptions).toPromise();
  }

  getDatosGeneralesComite(codigoEC: any) {
    let req = {
      codigoEC: codigoEC
    }
    return this.http.post<any>(`${this.getDatosGenerales}/${codigoEC}`, req, this.requestOptions).toPromise();
  }

  getEstandaresMarca(): Observable<any> {
    return this.http.get<any>(`${this.getEstandaresMarcau}`, this.requestOptions);
  }

  getEstandaresAll() {
    return this.http.get<any>(`${this.getEstandaresAllu}`, this.requestOptions).toPromise();
  }

  getSectoresProductivosByEstandar(estandar: string): Promise<any> {
    let req = {
      estandar: estandar
    }
    return this.http.post<any>(`${this.getSectoresByEstandar}/${estandar}`, req, this.requestOptions).toPromise();
  }

  getCursoById(idCurso: string): Promise<any> {
    return this.http.get<any>(`${this.getCursoByID}/${idCurso}`, this.requestOptions).toPromise();
  }

  getFichaEstandar(idEstandar: number): Promise<any> {
    return this.http.get<any>(`${this.getFichaestandar}?idEstandar=${idEstandar}`, this.requestOptions).toPromise();
  }


  getListaCursos(pageNumber: number, size: number, searchKey: string): Observable<any> {
    return this.http.get<any>(`${this.urlCursos}?pageNumber=${pageNumber}&size=${size}&searchKey=${searchKey}`, this.requestOptions);
  }

  getDetalleCurso(cursoID: number): Observable<any> {
    return this.http.get<any>(`${this.getDetailCurse}?cursoID=${cursoID}`, this.requestOptions);
  }


  getListRenap(curp: string) {
    return this.http.get<CompetensesResponse[]>(`${this.urlRenap}?curp=${curp}`, { observe: 'events' })
      .pipe(
        filter(event => event instanceof HttpResponse), 
        map((event: HttpResponse<CompetensesResponse[]>) => event.body!)
      );
  }

}
